import React, { useState } from 'react'
import { CardText } from 'reactstrap';
import moment from 'moment';

const Summary = (props) => {
    console.log(props)
    var eDate = props.event.date.toDate().toUTCString();
    var format = moment(props.event.date.toDate()).utc().format('LL');
    console.log(format)
    return (
      <div>
          <h2><CardText> {props.event.title} </CardText></h2>
          <h5><CardText> <b>Location:</b> {props.event.location} </CardText></h5>
          <h5><CardText> <b>Date:</b> {format} </CardText></h5>
          <h5><CardText> <b>Details:</b> {props.event.description} </CardText></h5>
      </div>
    )
  }

export default Summary;